<template>
  <v-container grid-list-xl>
    <alert-error :error="error"></alert-error>

    <v-card :disabled="readonly">
      <v-card-title>{{ $t('NOTIFICATIONS.CHOOSE_RECIPIENTS') }}</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-select
          v-model="businessCustomersSelected"
          :disabled="!(businessCustomersAll && businessCustomersAll.length)"
          :items="businessCustomersAll"
          item-value="id"
          item-text="name"
          multiple
          :label="$t('BUILDING_COMPLEXES.BUSINESS_CUSTOMER')"
          @change="changeBuildingComplexesForSelection"
        ></v-select>

        <v-select
          v-model="buildingComplexesSelected"
          :disabled="!(buildingComplexesAll && buildingComplexesAll.length)"
          :items="buildingComplexesForSelection"
          item-value="id"
          item-text="name"
          multiple
          :label="$t('BUILDING_COMPLEXES.ITEM')"
          @change="changeBuildingsForSelection"
        ></v-select>

        <v-select
          v-model="buildingsSelected"
          :disabled="
            !(
              buildingComplexesSelected &&
              buildingComplexesSelected.length &&
              buildingsAll
            )
          "
          :items="buildingsForSelection"
          item-value="id"
          item-text="street"
          multiple
          :label="$t('BUILDINGS.ITEM')"
        ></v-select>

        <v-select
          v-model="managementCompaniesSelected"
          :disabled="!(managementCompaniesAll && managementCompaniesAll.length)"
          :items="managementCompaniesAll"
          item-value="id"
          item-text="name"
          multiple
          :label="$t('BUILDING_COMPLEXES.MANAGEMENT_COMPANY')"
        ></v-select>

        <v-select
          v-model="tagsSelected"
          :disabled="!(tagsAll && tagsAll.length)"
          :items="tagsAll"
          item-value="id"
          item-text="name"
          multiple
          :label="$t('PERSONAL_INTERESTS.ITEMS')"
        ></v-select>

        <v-btn
          v-show="!readonly"
          :disabled="isEmptyFilter"
          @click="changeFilters()"
          >{{ $t('NOTIFICATIONS.FIND') }}</v-btn
        >
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'Filters',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  props: {
    filters: {
      type: Object,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    error: null,
    valid: true,

    businessCustomersAll: [],
    businessCustomersSelected: [],

    buildingComplexesAll: [],
    buildingComplexesForSelection: [],
    buildingComplexesSelected: [],

    buildingsAll: [],
    buildingsForSelection: [],
    buildingsSelected: [],

    managementCompaniesAll: [],
    managementCompaniesSelected: [],

    tagsAll: [],
    tagsSelected: []
  }),

  computed: {
    isEmptyFilter() {
      let isEmpty = true;
      if (
        (this.businessCustomersSelected &&
          this.businessCustomersSelected.length) ||
        (this.buildingComplexesSelected &&
          this.buildingComplexesSelected.length) ||
        (this.managementCompaniesSelected &&
          this.managementCompaniesSelected.length) ||
        (this.tagsSelected && this.tagsSelected.length)
      ) {
        isEmpty = false;
      }
      return isEmpty;
    }
  },

  created() {
    // get all business customers
    this.$store
      .dispatch('company/retrieveCompaniesByType', 1)
      .then(response => {
        this.businessCustomersAll = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });

    // get all building complexes
    this.$store
      .dispatch('building_complex/retrieveBuildingComplexesWithRelations')
      .then(response => {
        this.buildingComplexesAll = response.data;
        this.buildingComplexesForSelection = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });

    // get all management companies
    this.$store
      .dispatch('company/retrieveCompaniesByType', 2)
      .then(response => {
        this.managementCompaniesAll = response.data;
      })
      .catch(error => {
        this.error = error.response;
      });

    // get all personal interests
    this.$store
      .dispatch('tag/retrieveTags')
      .then(response => {
        this.tagsAll = response.data.data;
      })
      .catch(error => {
        this.error = error.response;
      });

    if (this.filters) {
      // ->action update | read
      if (this.filters.business_customers) {
        this.businessCustomersSelected = this.filters.business_customers;
      }
      if (this.filters.building_complexes) {
        this.buildingComplexesSelected = this.filters.building_complexes;
      }
      if (this.filters.buildings) {
        this.buildingsSelected = this.filters.buildings;
      }
      if (this.filters.management_companies) {
        this.managementCompaniesSelected = this.filters.management_companies;
      }
      if (this.filters.tags) {
        this.tagsSelected = this.filters.tags;
      }
    }
  },

  methods: {
    changeBuildingComplexesForSelection() {
      this.buildingComplexesSelected = [];
      this.buildingComplexesForSelection = [];
      this.buildingComplexesAll.forEach(buildingComplex => {
        if (this.businessCustomersSelected.length) {
          if (
            this.businessCustomersSelected.includes(
              buildingComplex.business_customer_id
            )
          ) {
            this.buildingComplexesForSelection.push(buildingComplex);
          }
        } else {
          this.buildingComplexesForSelection = this.buildingComplexesAll;
        }
      });
    },

    changeBuildingsForSelection() {
      this.buildingsSelected = [];
      this.buildingsForSelection = [];

      this.$store
        .dispatch('booking_reservations/getFilteredBuildings', {
          building_complex: this.buildingComplexesSelected
        })
        .then(response => {
          this.buildingsForSelection = response.data.data;
        })
        .catch(error => {
          this.error = error.response;
        });
    },

    isFullArray(mayBeArray) {
      return mayBeArray && mayBeArray.length;
    },

    changeFilters() {
      let newFilters = {};

      if (this.isFullArray(this.businessCustomersSelected)) {
        newFilters.business_customers = this.businessCustomersSelected;
      }

      if (this.isFullArray(this.buildingComplexesSelected)) {
        newFilters.building_complexes = this.buildingComplexesSelected;
      }

      if (this.isFullArray(this.buildingsSelected)) {
        newFilters.buildings = this.buildingsSelected;
      }

      if (this.isFullArray(this.managementCompaniesSelected)) {
        newFilters.management_companies = this.managementCompaniesSelected;
      }

      if (this.isFullArray(this.tagsSelected)) {
        newFilters.tags = this.tagsSelected;
      }

      this.$emit('change-filters', newFilters);
    }
  }
};
</script>
